import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ArchiveFileFormHeader } from '../models/archive/archive-file-form-header.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class ArchiveFileFormHeaderService extends RequestService<ArchiveFileFormHeader> {
  static PATH = '/archive/file/form/header';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(
      httpClient,
      ArchiveFileFormHeaderService.PATH,
      globalService.debugUrl
    );
  }
}
